module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAABTklEQVQ4T8WUL0zDUBDGv1u7YLAgpiCAweFIMGA2HjjEDAayEjSsxQKKZHQIFH86hZzC9M2BwBESSBgJCkkCGsHIemRNWljo9tqxwNl77/fdd+/dEfoc1GceQuDqoTukNWgTwHQyEbrRmUpHVu6ldS8EGrZ8JOCOCfVEQEaGgWzFFKMh0NiXsyBcOKboqQWGLRmMOccSlz7gT4C+SJdoVROklRUWSu4MpeiqG5AJ+UpRVH2H/2I5yUsrK4y0TNhximI3SkgJDF/+2+13pK7PrNxbz8BfWV633ckmqJ7SKHOyMf+cBLayJ0f0NJ7I86ZOtxZvv0avLO/BeAUh/F9BzwoHtXFiXo4UYmQBDDummGib5ajlkP5oLjUGdILnuUQ06Av+iA7LoZPNNVueM2FMY84fmwsPqnYol4FRltsaczUOrM2ySjluXllhXFBw7hN2proVbeHVGAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/center/comment.png
// module id = cTi5
// module chunks = 1